import React from "react";
import { HEXTooltipArrow } from "@icons/hexpert/HEXTooltipArrow";
import { HEXToolTipIcon } from "@icons/hexpert/HEXToolTipIcon";
import './ToolTip.scss';

type ToolTipProps = {
  text?: string; // @TODO: should probably be an rich area text
};

export const ToolTip = ({ text }: ToolTipProps) => {
  return (
    <div className="c-hex-tooltip-container">
      <HEXToolTipIcon />
      <div className="c-hex-tooltip-text-container">
        <HEXTooltipArrow />
        <div className="c-hex-tooltip-text">
          {text}
        </div>
      </div>
    </div>
  );
};
